const QUERY_EXTENDABLE_SUBSCRIPTION_TYPES = `
query QueryExtendableWebSubscriptionTypes {
  extendable_subscription_types_v3 {
    default_select_subscription_type_id
    needs_migration
    subscription_groups {
      subscription_types {
        id
        interval
        internal_name
        display_name_v2
        pretty_name
        max_totes
        clothing_count
        accessory_count
        base_price
        original_price
        description
        auto_renew_before_enable {
          is_display
          discount_amount
          description
        }
        available_promo_codes {
          code
          description
          discount_amount
          expiration_date
          status
          title
          rules
          type
          condition_display
          subscription_type_ids
        }
        operation_plan {
          icon_v3_url
          price_tips
          banner_v4_url
          referral_banner
        }
        is_accessory_slot_giveaway
        info_banner_config {
          banner_url
          tips
        }
        auto_renew_price_per_month
        preview {
          name
          expiration_date_tips
          cash_price
          final_price
          promo_code_price
          auto_renew_discount
          can_use_sales_code_v2
          referral_coupon_hint
          sales_code {
            title
            code
            amount
            applied
          }
          referral_code_v2 {
            title
            code
            amount
            applied  
          }
          percent_discount {
            amount
            percent
            title
          }
        }
        free_service_type {
          id
          name
          clothing_count
          free_service_type_config {
            popup_content {
              img_url
            }
          }
        }
      }
    }
  }
}
`

const QUERY_SUBSCRIPTION_TYPES = `
  query QueryWebSubscriptionTypes($filter: SubscriptionTypesFilter!, $occasion_filter: SubscriptionTypesOccasionFilter, $promo_code: String, $sales_code: String, $referral_code: String) {
    subscription_types(filter: $filter, occasion_filter: $occasion_filter) {
      id
      interval
      max_totes
      internal_name
      display_name_v2
      clothing_count
      accessory_count
      days_interval
      occasion
      occasion_display
      operation_plan {
        icon_v3_url
        price_tips
        banner_v4_url
        referral_banner
      }
      free_service_type {
        id
        name
        clothing_count
        free_service_type_config {
          popup_content {
            img_url
          }
        }
      }
      base_price
      original_price
      is_accessory_slot_giveaway
      info_banner_config {
        banner_url
        tips
      }
      auto_renew_price_per_month
      preview(promo_code: $promo_code, sales_code: $sales_code, referral_code: $referral_code) {
        name
        expiration_date_tips
        cash_price
        final_price
        promo_code_price
        auto_renew_discount
        can_use_sales_code_v2
        referral_coupon_hint
        sales_code {
          title
          code
          amount
          applied
        }
        referral_code_v2 {
          title
          code
          amount
          applied
        }
        percent_discount {
          amount
          percent
          title
        }
      }
    }
  }
`

const QUERY_SUBSCRIPTION_TYPE_PREVIEW = `
  query QueryWebSubscriptionType($id: ID, $promo_code: String, $sales_code: String, $referral_code: String, $is_charge_after_entrust: Boolean) {
    me {
      buy_subscription_page
      subscription {
        subscription_type {
          change_subscription_type_btn {
            state
            btn_tips
          }
        }
      }
    }
    subscription_type(id: $id) {
      days_interval
      ...currentSubscription
    }
  }

  fragment currentSubscription on SubscriptionType {
    id
    max_totes
    interval
    internal_name
    display_name_v2
    pretty_name
    clothing_count
    accessory_count
    base_price
    original_price
    auto_renew_before_enable {
      is_display
      discount_amount
      description
    }
    operation_plan {
      icon_v3_url
      price_tips
      banner_v4_url
      referral_banner
    }
    available_promo_codes {
      code
      description
      discount_amount
      expiration_date
      status
      title
      rules
      type
      condition_display
      subscription_type_ids
    }
    is_accessory_slot_giveaway
    auto_renew_price_per_month
    free_service_type {
      id
      name
      clothing_count
      free_service_type_config {
        popup_content {
          img_url
        }
      }
    }
    info_banner_config {
      banner_url
      tips
    }
    preview(promo_code: $promo_code, sales_code: $sales_code, referral_code: $referral_code, is_charge_after_entrust: $is_charge_after_entrust) {
      name
      expiration_date_tips
      cash_price
      final_price
      promo_code_price
      auto_renew_discount
      can_use_sales_code_v2
      referral_coupon_hint
      sales_code {
        title
        code
        amount
        applied
      }
      referral_code_v2 {
        title
        code
        amount
        applied
      }
      percent_discount {
        amount
        percent
        title
      }
    }
    xiaoyaoji_config {
      tips
      button_tips
      logos {
        name
        url
      }
      rules
    }  
  }
`

export default {
  QUERY_EXTENDABLE_SUBSCRIPTION_TYPES,
  QUERY_SUBSCRIPTION_TYPES,
  QUERY_SUBSCRIPTION_TYPE_PREVIEW
}
